import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import styles from './StagingBanner.module.css';

export const StagingBanner = () => {
  if (getEnvironment() !== 'staging') {
    return null;
  }
  return (
    <div className={styles.stagingBanner}>iwoca - Staging Environment</div>
  );
};
